/*jshint esversion: 8 */
import store from '../components/stores/Store';
import { hostIp } from "../config/ips";


const fetchPost = async (path, formData) => {
  try {
    console.log(`----- 开始通讯: `);
    const response = await fetch(
      `${hostIp}${path}`,
      {
        method: 'POST',
        body: formData,
        auth: store.user.JWTToken || '',
      });
    if (response.ok) {
      const rst = await response.json();
      rst.code = rst.code || 'success';
      rst.msg = rst.msg || 'success';
      return rst;
    }
    return {
      code: 'error',
      msg: response.statusText,
    };
  } catch (error) {
    console.error("----- fetchPost-error: ", error);
    return {
      code: 'error',
      msg: '网络超时',
    };
  }
};

const uploadImagesForTicket = async (formData) => {
  const rst = await fetchPost('/web_images/uploadImagesForTicket', formData);
  return rst;
};


export {
  fetchPost,
  uploadImagesForTicket,
};
